import type { GraphComponent } from '@/services/api/graph'

export interface ClusterListItemProps {
  component: GraphComponent
  label: string
  active: boolean
  onSelect: () => void
}

export function ClusterListItem({ component, label, active, onSelect }: ClusterListItemProps) {
  const types = component.entity_types.filter(Boolean)
  return (
    <button
      type="button"
      onClick={onSelect}
      aria-pressed={active}
      className={`w-full text-left rounded-md px-2 py-2 text-xs transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--ring)] ${
        active
          ? 'bg-[var(--accent)]/60 text-[var(--foreground)] border border-[var(--border)]'
          : 'text-[var(--muted-foreground)] hover:bg-[var(--muted)]/40 border border-transparent'
      }`}
    >
      <div className="flex items-center justify-between mb-0.5">
        <span className="font-medium text-[var(--foreground)]">{label}</span>
        <span className="tabular-nums">{component.size}</span>
      </div>
      <div className="flex gap-1 flex-wrap">
        {types.slice(0, 2).map(t => (
          <span
            key={t}
            className="inline-flex h-4 items-center rounded px-1 text-4xs font-medium bg-[var(--muted)]/60 text-[var(--muted-foreground)]"
          >
            {t}
          </span>
        ))}
        {types.length > 2 && (
          <span className="text-4xs text-[var(--muted-foreground)]">+{types.length - 2}</span>
        )}
      </div>
    </button>
  )
}
